import { createCollectionDomainHook } from './domainHookFactory';
import { radarOverlaysTranslator } from './translators/radarOverlays';
import type { RadarOverlayItem } from './types';

export const useRadarOverlaysSettings =
  createCollectionDomainHook<RadarOverlayItem>(
    'radar_overlays',
    'overlays',
    radarOverlaysTranslator,
  );
